// src/main.tsx or inside Index()
import { useAuth } from '@/context/auth-context'
import { useNotificationListener } from '@/context/notification-context'
import { useOrg } from '@/context/org-context'

function NotificationListenerWrapper({
  children,
}: {
  children: React.ReactNode
}) {
  const { user } = useAuth()
  const { currentOrg } = useOrg() // adjust based on your org-context keys

  const currentPortal = 'recruiter'
  // attach realtime Firestore listener
  useNotificationListener(user?.user_id, currentPortal, currentOrg?.id)

  return <>{children}</>
}

export default NotificationListenerWrapper
